export default "__VITE_ASSET__CB5K3wCk__"